import { createFileRoute, Navigate } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { CreateCommunicationPage } from "@/components/pages/CreateCommunicationPage";
import { trpc } from "@/lib/trpc";

export const Route = createFileRoute("/communications/create")({
  component: CreateCommunication,
});

function CreateCommunication() {
  const { data: user, isLoading } = trpc.user.me.useQuery();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <AppLayout>
      <CreateCommunicationPage />
    </AppLayout>
  );
}
